"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowOrchestratorClient = void 0;
var BaseClient_1 = require("./BaseClient");
var mock_1 = require("./utils/mock");
var FlowOrchestratorClient = /** @class */ (function (_super) {
    __extends(FlowOrchestratorClient, _super);
    function FlowOrchestratorClient(axiosClient) {
        var _this = _super.call(this, axiosClient) || this;
        _this.retrieveDraftTr = _this.retrieveDraftTr.bind(_this);
        _this.updateItem = _this.updateItem.bind(_this);
        _this.updateAddress = _this.updateAddress.bind(_this);
        _this.payShipment = _this.payShipment.bind(_this);
        _this.retrieveAvailableDates = _this.retrieveAvailableDates.bind(_this);
        _this.retrieveSelectedDates = _this.retrieveSelectedDates.bind(_this);
        _this.updateSelectedDates = _this.updateSelectedDates.bind(_this);
        _this.retrieveConfirmedDate = _this.retrieveConfirmedDate.bind(_this);
        _this.confirmDate = _this.confirmDate.bind(_this);
        _this.requestNewDates = _this.requestNewDates.bind(_this);
        _this.retrieveContact = _this.retrieveContact.bind(_this);
        _this.updateContact = _this.updateContact.bind(_this);
        _this.retrieveAvailableServices = _this.retrieveAvailableServices.bind(_this);
        _this.selectService = _this.selectService.bind(_this);
        _this.schedulingComplete = _this.schedulingComplete.bind(_this);
        _this.cancelDraftTr = _this.cancelDraftTr.bind(_this);
        _this.retrieveSupportRef = _this.retrieveSupportRef.bind(_this);
        _this.retrieveCtaUrlByShipmentAndEmail = _this.retrieveCtaUrlByShipmentAndEmail.bind(_this);
        return _this;
    }
    /**
     * Retrieves a draft TR by party id.
     */
    FlowOrchestratorClient.prototype.retrieveDraftTr = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'GET', url: "/draft_tr/".concat(partyId) })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Updates DraftTr's item and returns the new price
     */
    FlowOrchestratorClient.prototype.updateItem = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var party = _b.party, partyId = _b.partyId, item = _b.item;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'PATCH', url: "/".concat(party, "/item/").concat(partyId), data: { item: item } })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Updates DraftTr's item and returns the new price
     */
    FlowOrchestratorClient.prototype.updateAddress = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var party = _b.party, partyId = _b.partyId, address = _b.address;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'PATCH', url: "/".concat(party, "/address/").concat(partyId), data: { address: address } })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Triggers payment for a shipment
     */
    FlowOrchestratorClient.prototype.payShipment = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'POST', url: "/buyer/pay_shipment/".concat(partyId), data: {} })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Retrieve available dates
     */
    FlowOrchestratorClient.prototype.retrieveAvailableDates = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var party = _a.party, partyId = _a.partyId, mock = _a.mock, params = __rest(_a, ["party", "partyId", "mock"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'GET', params: params, url: "/".concat(party, "/available_dates/").concat(partyId) })];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Retrieve selected dates
     */ FlowOrchestratorClient.prototype.retrieveSelectedDates = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'GET', url: "/buyer/selected_dates/".concat(partyId) })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Update selected dates
     */
    FlowOrchestratorClient.prototype.updateSelectedDates = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var partyId = _a.partyId, mock = _a.mock, data = __rest(_a, ["partyId", "mock"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'POST', data: data, url: "/buyer/selected_dates/".concat(partyId) })];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Confirm date
     */
    FlowOrchestratorClient.prototype.confirmDate = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var partyId = _a.partyId, mock = _a.mock, data = __rest(_a, ["partyId", "mock"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'POST', data: data, url: "/seller/confirm_date/".concat(partyId) })];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Retrieve confirmed date
     */
    FlowOrchestratorClient.prototype.retrieveConfirmedDate = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'GET', url: "/seller/confirm_date/".concat(partyId) })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Request new dates
     */
    FlowOrchestratorClient.prototype.requestNewDates = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'POST', url: "/seller/request_new_dates/".concat(partyId) })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Retrieve contact
     */
    FlowOrchestratorClient.prototype.retrieveContact = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var party = _b.party, partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'GET', url: "/".concat(party, "/contact/").concat(partyId) })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Update contact
     */
    FlowOrchestratorClient.prototype.updateContact = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var party = _a.party, partyId = _a.partyId, mock = _a.mock, data = __rest(_a, ["party", "partyId", "mock"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'PATCH', data: data, url: "/".concat(party, "/contact/").concat(partyId) })];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Retrieve service advisory
     */
    FlowOrchestratorClient.prototype.retrieveAvailableServices = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, party = _b.party;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'GET', url: "/".concat(party, "/available_services/").concat(partyId) })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Select service
     */
    FlowOrchestratorClient.prototype.selectService = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var partyId = _a.partyId, party = _a.party, data = __rest(_a, ["partyId", "party"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'POST', data: data, url: "/".concat(party, "/select_service/").concat(partyId) })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Flow complete, indicates that we are ready to proceed to next state
     */
    FlowOrchestratorClient.prototype.schedulingComplete = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var party = _b.party, partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({
                            method: 'POST',
                            data: {},
                            url: "/".concat(party, "/scheduling_complete/").concat(partyId)
                        })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Cancel any non-completed DraftTR
     */
    FlowOrchestratorClient.prototype.cancelDraftTr = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partyId = _b.partyId, mock = _b.mock;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mock) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, mock_1.returnMock)(mock)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [4 /*yield*/, this.fetch({ method: 'POST', data: {}, url: "/buyer/cancel/".concat(partyId) })];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    FlowOrchestratorClient.prototype.retrieveSupportRef = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var shipmentId = _b.shipmentId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'GET', data: {}, url: "/shipments/support_ref/".concat(shipmentId) })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    FlowOrchestratorClient.prototype.retrieveCtaUrlByShipmentAndEmail = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var shipmentId = _b.shipmentId, email = _b.email;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({ method: 'GET', data: {}, params: { email: email }, url: "/shipments/".concat(shipmentId, "/party_url") })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    return FlowOrchestratorClient;
}(BaseClient_1.BaseClient));
exports.FlowOrchestratorClient = FlowOrchestratorClient;
